import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-affichage-consultation',
  templateUrl: './affichage-consultation.component.html',
  styleUrls: ['./affichage-consultation.component.scss']
})
export class AffichageConsultationComponent implements OnInit {
  pdfSrc: string = "assets/file/affiche/affiche_coronaviruse.pdf";
  pdfSrc2: string = "assets/file/affiche/affiche_kitrotro.pdf";
  constructor() { }

  ngOnInit() {
  }

}
